import MeetingCommentReply from './MeetingCommentReply'
import DeletedComment from './DeletedComment'
import DeletedCommentReply from './DeletedCommentReply'

export default class DeletedCommentDetail extends DeletedComment {
    commentReplyList: (MeetingCommentReply | DeletedCommentReply)[]

    constructor(
        meetingCommentId: number,
        message: string,
        commentReplyList: (MeetingCommentReply | DeletedCommentReply)[],
    ) {
        super(meetingCommentId, message)
        this.commentReplyList = commentReplyList
    }
}
